import React, { useState } from "react";
import Loader from "../../components/loader";
import UiTable from "../../components/table/Table";

import { useResolutionsData } from "../../context/contractDataLoaderService";
import WalletConnect from "../../components/common/walletConnect/index";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { providers } from "ethers";
import { useGlobal } from "../../context/globalContext";

function PendingOrders(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    userCountryCode,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const { data, loading } = useResolutionsData("All", "investorFacing");

  console.log("data: ", data);
  const headers = [
    { label: "Security", val: "securityTokenSymbol" },
    { label: "Issue type", val: "poolType" },
    { label: "Resolution", val: "offeringDocs" },
    { label: "Record date(UTC)", val: "date" },
    { label: "Voting", val: "isVotable" },
    { label: "Action", val: "voteResolution" },
  ];
  return (
    <>
      {loading ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="w-100">
          <h3 className="mb-3 d-flex">Resolutions</h3>
          <div className="pools-table width-100">
            <UiTable
              thead={headers}
              tbodyData={data ?? []}
              hover
              provider={provider}
              web3={web3}
              account={account}
              chainId={chainId}
              bordered={false}
            />
          </div>
        </div>
      </section>
      <WalletConnect loggedIn={props.loggedIn} />
    </>
  );
}

export default function Resolutions(props) {
  return <PendingOrders {...props} />;
}
